export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/fg-3-ef5739c9d6fa5cd99ec9be5befdff7fc.jpg";